import defaultOptions from "../config/config";

export default {
    /**
     * 加载Script
     */
    loadScript(trackerScript){
        return new Promise((resolve, reject) => {

            // var d=document;
            // g = d.createElement('script');
            // s = d.getElementsByTagName('script')[0];
            //
            // g.type='text/javascript';
            // g.async=true;
            // g.src=u+'matomo.js';
            // s.parentNode.insertBefore(g,s);

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.defer = true;
            script.src = trackerScript;
            const head = document.head || document.getElementsByTagName('head')[0];
            head.appendChild(script);

            script.onload = resolve;
            script.onerror = reject;
        })
    }
}
